import { ChangeDetectionStrategy, Component } from '@angular/core';
import { select, Store } from '@ngrx/store';

import { selectIsIntegrationAppConnected } from '../../connectivity/connectivity.selectors';

@Component({
    selector: 'se-estensa-review-confirmation-modal',
    styleUrls: ['./estensa-review-confirmation-modal.component.scss'],
    templateUrl: 'estensa-review-confirmation-modal.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EstensaReviewConfirmationModalComponent {
    isIntegrationAppConnected = this.store.pipe(select(selectIsIntegrationAppConnected));

    constructor(private store: Store) {}
}
